var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A21EF",
    d: "M14.521 4c-.73 0-1.43.29-1.947.807L4.461 12.92a1.575 1.575 0 0 0-.001 2.226l5.318 5.316V11.05c0-.703.565-1.272 1.267-1.272h11.177L28 4H14.52ZM9.778 22.222h11.173c.702 0 1.272-.57 1.272-1.271v-9.413l5.317 5.317c.307.307.46.71.46 1.112 0 .403-.153.806-.46 1.113l-8.113 8.114a2.755 2.755 0 0 1-1.948.806H4.001l5.777-5.778Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafepal);
export default __webpack_public_path__ + "static/media/safepal.2927b4cfff5181dff995003d38542f0d.svg";
export { ForwardRef as ReactComponent };